import { lazy, Suspense } from 'react'
import { Loader } from '../../shared'
import { AudiometerInstanceFormProps } from './AudiometerInstanceForm.model'

const LazyAudiometerInstanceForm = lazy(() =>
  import(
    /* webpackChunkName: "audiometry" */
    './AudiometerInstanceForm.component'
  ).then(({ AudiometerInstanceForm }) => ({ default: AudiometerInstanceForm })),
)

export const AudiometerInstanceForm = (props: AudiometerInstanceFormProps) => (
  <Suspense fallback={<Loader />}>
    <LazyAudiometerInstanceForm {...props} />
  </Suspense>
)
